import React from "react";
import { SecondaryCompactButton } from "./secondary-button";

interface ButtonSelectOption {
    id: string;
    label: string;
}

interface ButtonSelectProps {
    options: ButtonSelectOption[];
    selectedIds: string[];
    onToggle: (id: string) => void;
}

export const ButtonSelect: React.FC<ButtonSelectProps> = props => {
    const { options, selectedIds, onToggle } = props;
    return (
        <div className="flex flex-wrap gap-1.5 my-2">
            {options.map(option => (
                <SecondaryCompactButton
                    key={option.id}
                    type="button"
                    selected={selectedIds.includes(option.id)}
                    onClick={() => onToggle(option.id)}>
                    {option.label}
                </SecondaryCompactButton>
            ))}
        </div>
    );
};
